// extracted by mini-css-extract-plugin
export default {"searchWrapper":"Search_searchWrapper__wC-zD"};